import { render, staticRenderFns } from "./List.vue?vue&type=template&id=64025ed6&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64025ed6')) {
      api.createRecord('64025ed6', component.options)
    } else {
      api.reload('64025ed6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=64025ed6&", function () {
      api.rerender('64025ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/message/List.vue"
export default component.exports